"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.processValue = exports.processStringValue = exports.getInitialValue = void 0;
var _isISO = _interopRequireDefault(require("validator/lib/isISO8601"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// Previously value was just a string date
// Then we decided to save additional information such as startedAt
// That's why we need this function to convert string to object to not have breaking changes
var processValue = exports.processValue = function processValue(value) {
  if (_typeof(value) === 'object') {
    return _objectSpread({
      date: null,
      startedAt: ''
    }, value);
  }
  return {
    date: value || null,
    startedAt: ''
  };
};
var processStringValue = exports.processStringValue = function processStringValue(value) {
  value = value.replace(/[^\d/]+/g, '');
  var count = 0;
  value = value.replace(/^(\d)(\d)$/, function (match, digit1, digit2) {
    return +match > 12 ? "".concat(digit1, "/").concat(digit2) : match;
  }).replace(/^(\d+\/)(\d)(\d)$/, function (match, month, digit1, digit2) {
    return +(digit1 + digit2) > 31 ? "".concat(month).concat(digit1, "/").concat(digit2) : match;
  }).split('/').map(function (part) {
    return part.length > 2 ? part.replace(/(\d\d)/g, '$1/').replace(/\/$/, '') : part;
  }).join('/').replace(/^\//, '').replace(/\/\/+/, '/').replace(/\//g, function (ch) {
    return ++count > 2 ? '' : ch;
  }).replace(/(\/\d{4})\d+$/, '$1');
  return value;
};
var validate = exports.validate = function validate(value) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error;
  var _processValue = processValue(value),
    date = _processValue.date;
  if (!date && settings.isRequired) {
    return settings.requiredErrorMessage;
  }
  if (date) {
    var currentDate = (0, _format["default"])(new Date(), 'YYYY-MM-DD');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !(0, _isISO["default"])(date)) {
      return 'Invalid date';
    }
    if (settings.disallowPastDates && date < currentDate) {
      return 'Past date is not allowed';
    }
    if (settings.disallowFutureDates && date > currentDate) {
      return 'Future date is not allowed';
    }
  }
  return error;
};
var getInitialValue = exports.getInitialValue = function getInitialValue() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultValueVariables = arguments.length > 1 ? arguments[1] : undefined;
  if (defaultValueVariables && settings.defaultValueVariable) {
    var defaultValue = (0, _get2["default"])(defaultValueVariables, settings.defaultValueVariable);
    if (!defaultValue) {
      console.error("There is no variable \"".concat(settings.defaultValueVariable, "\""));
    } else {
      return defaultValue;
    }
  }
  return undefined;
};